export const BASE_URL="https://api.themoviedb.org/3";
export const API_KEY="f0da957bba4f43e31176f9fe9dc3b234";